'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.thunk = thunk;

var _h = require('./h');

function init(thunk) {
  var cur = thunk.data;
  cur.vnode = cur.fn.apply(undefined, cur.args);
}

function prepatch(oldThunk, thunk) {
  // eslint-disable-line complexity
  var old = oldThunk.data;
  var cur = thunk.data;
  var oldArgs = old.args;
  var args = cur.args;
  cur.vnode = old.vnode;

  if (old.fn !== cur.fn || oldArgs.length !== args.length) {
    cur.vnode = cur.fn.apply(undefined, args);
    return;
  }
  for (var i = 0; i < args.length; ++i) {
    if (oldArgs[i] !== args[i]) {
      cur.vnode = cur.fn.apply(undefined, args);
      return;
    }
  }
}

function thunk(name, fn) {
  for (var _len = arguments.length, args = Array(_len > 2 ? _len - 2 : 0), _key = 2; _key < _len; _key++) {
    args[_key - 2] = arguments[_key];
  }

  return (0, _h.h)('thunk' + name, {
    hook: { init: init, prepatch: prepatch },
    fn: fn, args: args
  });
}


/** WEBPACK FOOTER **
 ** ./~/@motorcycle/dom/lib/hyperscript/thunk.js
 **/